// AUTO-GENERATED by scripts/sync-version.mjs — do not edit by hand.
// Counts up on every PRODUCTION deploy (npm run version:bump). Baked into both
// apps at build time; drives the silent force-upgrade in <VersionGuard /> and the
// /api/version endpoint. A running client whose APP_VERSION is lower than the live
// /api/version hard-refreshes itself onto the new release.
export const APP_VERSION = 478;
